import { useEmployeeFormContext } from 'src/components/enterprise/features/Employee/components/Form/EmployeeFormProvider/useEmployeeFormContext';

type UseSubDepartmentControlWrapperReturn = {
  isVisible: boolean;
};

export function useSubDepartmentControlWrapper(): UseSubDepartmentControlWrapperReturn {
  const {
    corpData: { subDepartmentEnabled: isVisible },
  } = useEmployeeFormContext();

  return {
    isVisible,
  };
}
